/**
 * True when the runtime has a touch digitizer.
 * Prefer `navigator.maxTouchPoints` — `'ontouchstart' in window` is true in
 * jsdom (and some desktops) without an actual touch screen, which incorrectly
 * routes mouse clicks through long-press handlers.
 *
 * @returns {boolean}
 */
export function detectTouchDevice() {
  if (typeof navigator === 'undefined') return false;
  return navigator.maxTouchPoints > 0;
}
